/**
 * @param {number} value like 20190801
 * @returns {string} like '01.08.2019' or ''
 */
export default value => {
    const str = String(value);

    if (str.length != 8) return '';

    const d = str.slice(6, 8);
    const m = str.slice(4, 6);
    const y = str.slice(0, 4);

    return `${d}.${m}.${y}`;
};
